module.exports = __webpack_public_path__ + "img/42.be887a0f.jpg";